import io from 'socket.io-client';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.pawaschool.net/api/v1';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_URL.replace(/\/api\/v1$/, '');

const token = localStorage.getItem('token');

export const socket = io(SOCKET_URL, {
  transports: ['websocket', 'polling'],
  withCredentials: true,
  auth: { token },
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

// Use our custom REACT_APP_ENV variable
const isDev = process.env.REACT_APP_ENV === 'development';

socket.on('connect', () => {
});

socket.on('connect_error', (err) => {
  console.error('❌ Socket error:', err.message);
});